import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	addThumbsUpReactionLabel: {
		id: 'issue.reactions.add-thumbs-up-reaction',
		defaultMessage: 'Add thumbs up reaction',
		description: 'Label for the add thumbs up reaction button',
	},
	thumbsUp: {
		id: 'issue.reactions.thumbs-up',
		defaultMessage: 'Thumbs up',
		description: 'Label for the add thumbs up reaction button',
	},
});
